/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Performer } from '../models/Performer';
import type { PerformerContract } from '../models/PerformerContract';
import type { TCreatePerformerRequest } from '../models/TCreatePerformerRequest';
import type { TCreatePerformerResponse } from '../models/TCreatePerformerResponse';
import type { TGetPerformerResponse } from '../models/TGetPerformerResponse';
import type { THireExistingPerformerRequest } from '../models/THireExistingPerformerRequest';
import type { THireExistingPerformerResponse } from '../models/THireExistingPerformerResponse';
import type { TListPerformersResponse } from '../models/TListPerformersResponse';
import type { TLookupPerformerResponse } from '../models/TLookupPerformerResponse';
import type { TPerformerId } from '../models/TPerformerId';
import type { TPerformerInviteRequest } from '../models/TPerformerInviteRequest';
import type { TUpdatePerformerRequest } from '../models/TUpdatePerformerRequest';
import type { TUpdatePerformerResponse } from '../models/TUpdatePerformerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformerService {
    /**
     * Lookup Performer by email
     * @param email
     * @param projectId
     * @returns TLookupPerformerResponse TLookupPerformerResponse
     * @throws ApiError
     */
    public static lookupPerformerByEmail(
        email: string,
        projectId: string,
    ): CancelablePromise<TLookupPerformerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/performers/lookup',
            query: {
                'email': email,
                'projectId': projectId,
            },
        });
    }
    /**
     * Get Performer
     * @param id
     * @param relations
     * @returns TGetPerformerResponse TGetPerformerResponse
     * @throws ApiError
     */
    public static getPerformer(
        id: TPerformerId,
        relations?: string,
    ): CancelablePromise<TGetPerformerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/performers/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update Performer
     * @param id
     * @param requestBody
     * @returns TUpdatePerformerResponse TUpdatePerformerResponse
     * @throws ApiError
     */
    public static updatePerformer(
        id: TPerformerId,
        requestBody: TUpdatePerformerRequest,
    ): CancelablePromise<TUpdatePerformerResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/performers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Performer
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deletePerformer(
        id: TPerformerId,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/performers/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * List Performers
     * @param projectId
     * @param search
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @param includeAccountPerformers
     * @returns TListPerformersResponse TListPerformersResponse
     * @throws ApiError
     */
    public static listPerformers(
        projectId?: string,
        search?: string,
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
        includeAccountPerformers?: boolean,
    ): CancelablePromise<TListPerformersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/performers',
            query: {
                'projectId': projectId,
                'search': search,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
                'includeAccountPerformers': includeAccountPerformers,
            },
        });
    }
    /**
     * Create Performer
     * @param requestBody
     * @returns TCreatePerformerResponse TCreatePerformerResponse
     * @throws ApiError
     */
    public static createPerformer(
        requestBody: TCreatePerformerRequest,
    ): CancelablePromise<TCreatePerformerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/performers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Hire existing performer
     * @param requestBody
     * @returns THireExistingPerformerResponse THireExistingPerformerResponse
     * @throws ApiError
     */
    public static hireExistingPerformer(
        requestBody: THireExistingPerformerRequest,
    ): CancelablePromise<THireExistingPerformerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/performers/hire',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Invite performer to complete onboarding
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static invitePerformer(
        requestBody: TPerformerInviteRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/performers/{id}/invite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Validate Performer Invite Token
     * @param token
     * @returns any Ok
     * @throws ApiError
     */
    public static validatePerformerOnboardingToken(
        token: string,
    ): CancelablePromise<{
        contract: PerformerContract;
        performer: Performer;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/performers/onboarding/validate/{token}',
            path: {
                'token': token,
            },
        });
    }
    /**
     * Upload Performer selfie
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static uploadPerformerSelfie(
        formData: {
            selfie: Blob;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/performers/onboarding/selfie',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Performer selfie URL
     * @param performerId
     * @returns any Signed URL for accessing the selfie
     * @throws ApiError
     */
    public static getPerformerSelfieUrl(
        performerId: TPerformerId,
    ): CancelablePromise<{
        url: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/performers/{performerId}/selfie-url',
            path: {
                'performerId': performerId,
            },
        });
    }
}
